<template>
  <RevInputSelect
    :id="fieldName"
    v-model="model"
    data-cs-mask
    :error
    :label
    :name="fieldName"
    :options
  />
</template>

<script setup lang="ts">
import {
  type Option,
  RevInputSelect,
  type Value,
} from '@ds/components/InputSelect'

defineProps<{
  fieldName: string
  label: string
  error?: string
  options: Option[]
}>()

const model = defineModel<Value>({ required: true })
</script>
